<script setup>
import { ref, watch } from "vue";
import WrCrossIcon from "../atoms/icons/WrCrossIcon.vue";

import content from "../../pages/services/maintenance-services/wordpress/install.json";

const packages = content?.package_details?.packages;

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
    required: true,
  },
  item: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["close", "closeAndPaymentOpen"]);
const visible = ref(props.isOpen);

const handleCloseAndPaymentOpen = () => {
  visible.value = false;
  emit("closeAndPaymentOpen");
};

watch(
  () => props.isOpen,
  (newVal) => {
    visible.value = newVal;
  }
);

watch(visible, (newVal) => {
  if (!newVal) {
    emit("close");
  }
});

const handleClose = () => {
  visible.value = false;
};

const selectedTabIndex = ref(0);

watch(
  () => props.item,
  (newItem) => {
    const index = packages.findIndex((p) => p.title === newItem);
    if (index !== -1) {
      selectedTabIndex.value = index;
      console.log("Active tab updated to:", index);
    }
  }
);
</script>

<template>
  <div class="card flex justify-center z-30">
    <Dialog
      v-model:visible="visible"
      :modal="true"
      :dismissableMask="true"
      closeOnEscape
      closable
      unstyled
      class="w-[95vw] md:w-[60vw] bg-white dark:bg-transparent"
      :breakpoints="{ '1199px': '50vw', '575px': '90vw' }"
      :pt="{
        root: {
          class:
            'relative dark:bg-[linear-gradient(92.4deg,_rgba(53,9,91)_6.22%,rgba(63,0,119)_93.78%)] rounded-xl',
        },
        headerActions: {
          class: 'hidden',
        },
        mask: {
          class: 'backdrop-blur-sm bg-black/50',
        },
        content: { class: 'max-h-[90dvh] max-md:min-h-[90dvh] overflow-y-auto' },
      }"
    >
      <template #header>
        <div class="absolute -top-3 -right-3 z-50">
          <button @click="handleClose">
            <WrCrossIcon
              class="text-white p-1 bg-[#5f4ca4] rounded-full border-2"
            />
          </button>
        </div>
      </template>
      <div class="p-6 rounded-xl">
        <h2 class="text-2xl md:text-4xl font-extrabold mb-3 text-center">
          The Packages Included
        </h2>
        <p
          class="max-w-3xl mx-auto mb-10 md:text-lg text-center tracking-[0.5px]"
        >
          Also, do you want to spend a lot of time tracking every detail in your
          business? We don’t think so. We’ve got these packages that are just
          right for you
        </p>

        <div class="max-w-5xl mx-auto">
          <Tabs
            v-model:value="selectedTabIndex"
            :value="0"
            class="flex flex-col lg:!flex-row w-full"
          >
            <TabList
              class="flex flex-col w-full"
              :pt="{
                tabList: {
                  class:
                    'flex lg:flex-col w-full max-lg:overflow-x-auto no-scrollbar !bg-transparent',
                },
                prevButton: { class: '!hidden' },
                nextButton: { class: '!hidden' },
                activeBar: { class: 'hidden' },
              }"
            >
              <Tab
                v-for="(item, index) in packages"
                :key="index"
                :value="item.value"
                as="div"
                :class="[
                  'max-md:px-4 md:pl-0 md:pr-4 py-3 text-left transition-all font-medium text-sm',
                  item.value === index
                    ? 'focus:text-[#5f4ca4] focus:border-[#5f4ca4]'
                    : 'border-b hover:bg-gray-100 !text-gray-200 ',
                ]"
              >
                {{ item.title }}
              </Tab>
            </TabList>

            <TabPanels
              class="mt-6 md:mt-0 md:px-[4rem] md:pt-2 !bg-transparent"
            >
              <TabPanel
                v-for="(item, index) in packages"
                :key="index"
                :value="item.value"
              >
                <h3 class="text-2xl font-bold mb-4">{{ item.title }}</h3>
                <p class="text-base tracking-[0.5px] !leading-[1.8] mb-6">
                  {{ item.description }}
                </p>
                <WrButton @click="handleCloseAndPaymentOpen">
                  Purchase $29
                </WrButton>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </div>
      </div>
    </Dialog>
  </div>
</template>
